import { MainCardContainer, TagComponent, TitleSection } from "./styled";

import { styled, useTheme } from "@mui/system";

import { Typography, Avatar } from "@mui/material";
import { PriceComponent } from "components/Shared/Dashboard/styled";
import { formatPrice } from "helpers/dataFormat";

const MainSectionContainer = styled("div")(({ theme }) => ({
  width: "100%",
  height: "100%",
  padding: "16px",
}));
const MainSection = styled("div")(({ theme }) => ({
  width: "100%",
  height: "100%",
  backgroundColor: "#f9fafe",
  borderRadius: theme.shape.borderRadius,
  padding: "24px",
  display: "grid",
  gridTemplateRows: "45% 45%",
  gridGap: "10%",
}));

const FactorItemContainer = styled("div")(({ theme }) => ({
  width: "100%",
  height: "100%",
  display: "grid",
  gridTemplateRows: "50% 50%",
}));
const SubItemTitleContainer = styled("div")(({ theme }) => ({
  borderBottom: `solid 3px #E0E0E0`,
  height: "55px",
}));

const SubItemTitleText = styled("div")(({ theme }) => ({
  display: "flex",
}));
const SubItemItemTitleText = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "140px",
}));
const SubItemBodyContainer = styled("div")(({ theme }) => ({
  width: "100%",
  marginBottom: "10px",
  height: "100%",
  display: "grid",
  gridTemplateColumns: "50% 50%",
}));
const SubItemItemContainer = styled("div")(({ theme }) => ({
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  marginTop: "6px",
  marginBottom: "6px",
}));

const FactorItem = ({
  type,
  transfered,
  factor,
  countTransfered,
  countFactor,
}: {
  type: "buy" | "sell";
  factor: number;
  transfered?: number;
  countTransfered: number;
  countFactor: number;
}) => {
  const theme = useTheme();
  return (
    <FactorItemContainer>
      <SubItemTitleContainer>
        <SubItemTitleText>
          <Typography
            color={type === "sell" ? theme.palette.error.main : theme.palette.success.main}
            variant="h6"
          >
            {type === "sell" ? "فروش" : "خرید"}
          </Typography>
        </SubItemTitleText>
      </SubItemTitleContainer>
      <SubItemBodyContainer>
        <SubItemItemContainer>
          <SubItemItemTitleText>
            <Typography color={theme.palette.disabled.main}>مجموع</Typography>
            <TagComponent title={formatPrice(factor)} />
          </SubItemItemTitleText>
        </SubItemItemContainer>
        {transfered !== undefined && (
          <SubItemItemContainer>
            <SubItemItemTitleText>
              <Typography color={theme.palette.disabled.main}>سود</Typography>
              <TagComponent title={formatPrice(transfered)} />
            </SubItemItemTitleText>
          </SubItemItemContainer>
        )}
        <SubItemItemContainer>
          <SubItemItemTitleText>
            <Typography color={theme.palette.disabled.main}>تعداد</Typography>
            <TagComponent title={formatPrice(countTransfered)} />
          </SubItemItemTitleText>
        </SubItemItemContainer>
        <SubItemItemContainer>
          <SubItemItemTitleText>
            <Typography color={theme.palette.disabled.main}>فاکتورها</Typography>
            <TagComponent title={countFactor} />
          </SubItemItemTitleText>
          {/*<PriceComponent price={formatPrice(factor)} />*/}
        </SubItemItemContainer>
        <SubItemItemContainer></SubItemItemContainer>
      </SubItemBodyContainer>
    </FactorItemContainer>
  );
};

const ProductFactorSection = ({ data }: { data: any }) => {
  return (
    <MainCardContainer>
      <TitleSection />
      <MainSectionContainer>
        <MainSection>
          <FactorItem
            transfered={data?.totalAmountSold}
            factor={data?.totalAmountSaleFactor}
            countTransfered={data?.Sold}
            countFactor={data?.countSaleFactors}
            type="sell"
          />
          <FactorItem
            // transfered={data?.totalAmountBought}
            factor={data?.totalAmountBuyFactor}
            countTransfered={data?.bought}
            countFactor={data?.countBuyFactors}
            type="buy"
          />
        </MainSection>
      </MainSectionContainer>
    </MainCardContainer>
  );
};

export default ProductFactorSection;
